<template>
  <span>{{ formattedTime }}</span>
</template>
<script setup lang="ts">
import { computed, defineEmits, onBeforeMount, onMounted, ref, watch } from 'vue';
import { useIntervalFn } from '@vueuse/core';
// import dayjs from 'dayjs';

type Props = {
  targetDate?: number;
  id?: number;
};

const props = withDefaults(defineProps<Props>(), {});

const emits = defineEmits(['time-end']);

const currentTime = ref<any>();

const { pause, resume } = useIntervalFn(
  () => {
    currentTime.value = Date.now();
  },
  1000,
  { immediate: true }
);

const timeDifference = computed(() => {
  return props.targetDate && currentTime.value ? props.targetDate - currentTime.value : 0;
});

const formattedTime = computed(() => {
  const seconds = Math.floor(timeDifference.value / 1000) % 60;
  const minutes = Math.floor(timeDifference.value / (1000 * 60)) % 60;
  const hours = Math.floor(timeDifference.value / (1000 * 60 * 60)) % 24;
  // const days = Math.floor(timeDifference.value / (1000 * 60 * 60 * 24));
  return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  // return `${days} 天 ${hours} 小时 ${minutes} 分钟 ${seconds} 秒`;
});

watch(
  () => props.targetDate,
  value => {
    if (value) {
      resume();
    } else {
      pause();
    }
  }
);

watch(
  () => timeDifference.value,
  value => {
    // console.log(value, 'timeDifference');
    if (value < 1000) {
      pause();
      emits('time-end', props.id);
    }
  }
);

onMounted(async () => {
  if (props.targetDate) {
    resume();
  }
});

onBeforeMount(() => {
  pause();
});
</script>
<style lang="less" scoped></style>
